class FavoriteButton extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.isActive = this.hasAttribute("active");
    this.productId = this.id.split("-")[1];
  }

  init() {
    this.addEventListener("click", (e) => this.handleFav(e));
  }

  async handleFav(e) {
    e.preventDefault();
    e.stopPropagation();

    const customerId = window.ShopifyAnalytics.meta.page.customerId || window.logged_in_customer_id;

    if (!customerId) return;
    // thay bang redirect sang trang login
    this.updateAppearance();

    try {
      await fetch("https://smilegrows.vercel.app/api/proxy/customer/favorite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: this.productId,
          value: !this.isActive,
          customerId,
          shop: window.shopDomain,
        }),
      });
      this.isActive = !this.isActive;
    } catch {
      this.updateAppearance(this.isActive);
    }
  }

  updateAppearance(state = !this.isActive) {
    if (state) this.setAttribute("active", "");
    else this.removeAttribute("active");
  }
}

customElements.define("favorite-button", FavoriteButton);
